import React, { useState } from "react";
import { motion } from "framer-motion";
import { Sun, Moon, Lock, Bell, User, Save, PlusCircle } from "lucide-react";
import Sidebar from "../Side/Sidebar";
import Topbar from "../Side/Topbar";
import AdminSidebar from "../Side/AdminSidebar";
import { useAuth } from "../Auth/AuthContext";
import { useNavigate } from "react-router-dom";

const AdminSettings = () => {
    const [darkMode, setDarkMode] = useState(false);
    const [notifications, setNotifications] = useState(true);
    const [name, setName] = useState("Admin User");
    const [email, setEmail] = useState("admin@example.com");
    const [password, setPassword] = useState("");
    const { authState } = useAuth();
    const role = authState.roles;
    const admin = role === "Admin";
    const navigate = useNavigate();

    const toggleDarkMode = () => {
        setDarkMode(!darkMode);
        document.documentElement.classList.toggle("dark");
    };

    return (
        <div className="min-h-screen flex flex-col md:flex-row">
            {admin ? <AdminSidebar /> : <Sidebar />}

            <div className="flex-1 bg-gray-100">
                <div className="flex-1 flex flex-col">
                    <Topbar />

                    <main className="pt-[100px] px-4">
                        <div className="mt-6">
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5 }}
                                className={`p-6 max-w-lg mx-auto rounded-lg shadow-lg ${darkMode ? "bg-gray-900 text-white" : "bg-white text-gray-900"}`}
                            >
                                <h2 className="text-2xl font-bold mb-4">Admin Settings</h2>

                                <div className="flex items-center justify-between mb-4">
                                    <span className="flex items-center gap-2 text-lg">
                                        {darkMode ? <Moon size={20} /> : <Sun size={20} />} Dark Mode
                                    </span>
                                    <motion.button whileTap={{ scale: 0.9 }} onClick={toggleDarkMode} className="p-2 rounded-full bg-gray-200 dark:bg-gray-700">
                                        {darkMode ? <Sun size={22} className="text-yellow-500" /> : <Moon size={22} className="text-gray-800" />}
                                    </motion.button>
                                </div>

                                <div className="flex items-center justify-between mb-4">
                                    <span className="flex items-center gap-2 text-lg"><Bell size={20} /> Notifications</span>
                                    <motion.button whileTap={{ scale: 0.9 }} onClick={() => setNotifications(!notifications)} className={`p-2 rounded-full ${notifications ? "bg-green-500 text-white" : "bg-gray-300"}`}>
                                        {notifications ? "ON" : "OFF"}
                                    </motion.button>
                                </div>

                                <div className="mb-4">
                                    <label className="block text-lg font-semibold mb-1">Name</label>
                                    <div className="flex items-center gap-2 p-2 border rounded-lg bg-gray-100 dark:bg-gray-800">
                                        <User size={20} />
                                        <input type="text" value={name} onChange={(e) => setName(e.target.value)} className="bg-transparent outline-none w-full" />
                                    </div>
                                </div>

                                <div className="mb-4">
                                    <label className="block text-lg font-semibold mb-1">Email</label>
                                    <div className="flex items-center gap-2 p-2 border rounded-lg bg-gray-100 dark:bg-gray-800">
                                        <User size={20} />
                                        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="bg-transparent outline-none w-full" />
                                    </div>
                                </div>

                                <div className="mb-4">
                                    <label className="block text-lg font-semibold mb-1">New Password</label>
                                    <div className="flex items-center gap-2 p-2 border rounded-lg bg-gray-100 dark:bg-gray-800">
                                        <Lock size={20} />
                                        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="bg-transparent outline-none w-full" />
                                    </div>
                                </div>

                                <motion.button whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }} className="w-full bg-blue-600 text-white py-2 rounded-lg flex items-center justify-center gap-2">
                                    <Save size={20} /> Save Changes
                                </motion.button>

                                <div className="flex gap-4 mt-4">
                                    <motion.button whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }} onClick={() => navigate("/adunits")} className="flex-1 bg-purple-600 text-white py-2 rounded-lg flex items-center justify-center gap-2">
                                        <PlusCircle size={20} /> Add Unit
                                    </motion.button>
                                    <motion.button whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }} onClick={() => navigate("/AdsTxtConfiguration")} className="flex-1 bg-green-600 text-white py-2 rounded-lg flex items-center justify-center gap-2">
                                        <PlusCircle size={20} /> Add TXT
                                    </motion.button>
                                    <motion.button whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }} onClick={() => navigate("/AdsCodeConfiguration")} className="flex-1 bg-red-600 text-white py-2 rounded-lg flex items-center justify-center gap-2">
                                        <PlusCircle size={20} /> Add Code
                                    </motion.button>
                                </div>
                            </motion.div>
                        </div>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default AdminSettings;
